import React from 'react';
import { CircleCheck, CircleDashed, CircleDot } from 'lucide-react';

/**
 * Check-in readiness at the top of the sidebar.
 *
 * `items` is [{ label, done, target, pending }]. A `pending` item has no data behind it yet: it is
 * listed, muted, and left out of the score. Clicking an item with a `target` scrolls to that card.
 *
 * Which checks count is open question Q4; CamperDetail builds the list.
 */
const ReadinessCard = ({ items }) => {
    const scored = items.filter(i => !i.pending);
    const done = scored.filter(i => i.done).length;
    const ready = scored.length > 0 && done === scored.length;
    const pct = scored.length ? Math.round((done / scored.length) * 100) : 0;

    const goTo = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    return (
        <section aria-label="Check-in readiness" className="booking-detail-page tw-mb-6 tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-px-4 tw-py-3">
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                <h2 className="tw-m-0 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-neutral-700">Check-in readiness</h2>
                <span className={`tw-text-sm tw-font-semibold ${ready ? 'tw-text-green-700' : 'tw-text-red-600'}`}>{done}/{scored.length}</span>
            </div>
            <div className="tw-mt-2 tw-h-1.5 tw-overflow-hidden tw-rounded-full tw-bg-neutral-200" role="progressbar" aria-valuemin={0} aria-valuemax={scored.length} aria-valuenow={done}>
                <div className={`tw-h-full tw-rounded-full ${ready ? 'tw-bg-green-600' : 'tw-bg-red-600'}`} style={{ width: `${pct}%` }} />
            </div>
            <ul className="tw-mt-3 tw-flex tw-flex-col tw-gap-1.5">
                {items.map(item => {
                    const Icon = item.pending ? CircleDashed : (item.done ? CircleCheck : CircleDot);
                    const tone = item.pending ? 'tw-text-neutral-400' : (item.done ? 'tw-text-green-700 tw-line-through' : 'tw-text-red-600');
                    const content = <>
                        <Icon className="tw-h-4 tw-w-4 tw-shrink-0" aria-hidden="true" />
                        <span>{item.label}</span>
                    </>;
                    return (
                        <li key={item.label}>
                            {item.target
                                ? <button type="button" onClick={() => goTo(item.target)} className={`tw-flex tw-items-center tw-gap-2 tw-text-left tw-text-sm hover:tw-underline ${tone}`}>{content}</button>
                                : <span className={`tw-flex tw-items-center tw-gap-2 tw-text-sm ${tone}`}>{content}</span>}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export default ReadinessCard;
